export default "__VITE_ASSET__DLGPR7yh__"